<template>
  <div class="content-editor-block title">
    <el-input v-model="mValue" @input="onInput" placeholder="請輸入標題"></el-input>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: ''
    }
  },
  data: () => {
    return {
      mValue: ''
    }
  },
  computed: {
  },
  methods: {
    onInput () {
      this.$emit('input', this.mValue)
    }
  },
  created () {
    this.mValue = this.value
  },
  watch: {
    value () {
      this.mValue = this.value
    }
  }
}
</script>
